export default __webpack_public_path__ + "static/17292-98eceb147c1039797163d05bd0e14040.jpg";